<template>
    <ion-buttons>
        <ion-button
            @click.stop="$refs['assignees'].open(users)"
            class="people-count"
            color="primary"
            fill="outline"
            size="medium"
        >
            <ion-icon :icon="peopleOutline"/>
            {{ users.length }}
        </ion-button>
        <ion-button
            :color="getMembershipStatusColour(users, 'accept')"
            fill="outline"
            expand="block"
            size="medium"
            @click.stop="acceptJob()"
            v-if="!hideAcceptReject"
        >
            <ion-icon :icon="checkmarkCircleOutline"/>
        </ion-button>
        <ion-button
            :color="getMembershipStatusColour(users, 'reject')"
            fill="outline"
            expand="block"
            size="medium"
            @click.stop="rejectJob()"
            v-if="!hideAcceptReject"
        >
            <ion-icon :icon="closeCircleOutline"></ion-icon>
        </ion-button>
        <people-assigned-to-shipment-alert
            :shipment="job"
            ref="assignees"
            header="Users"
            :subtitle="`Assigned to ${name}`"
            :offer-jump-to-pack="stage == 'pack'"
            :offer-jump-to-check="stage == 'check'"
        />
    </ion-buttons>
</template>
<script>
import PeopleAssignedToShipmentAlert from "@/components/Alerts/PeopleAssignedToShipmentAlert";
import {checkmarkCircleOutline, closeCircleOutline, ellipse, peopleOutline} from 'ionicons/icons';
import {IonButtons, IonIcon, IonButton, alertController} from '@ionic/vue';
import _ from "lodash";
import EventBus from "@/EventBus";

/**
 * users - the list of users that will be presented as assigned/candidates
 * name - used to describe what the user is signing up to in the alert?
 * job - the shipment/stocktake - the thing with the id
 * type - "stocktakes" or "shipments"
 * stage - shipment only : "pick", "check", "pack"
 */
export default {
    name: 'ShipmentMembershipTools',
    inject: ['$http'],
    components: {IonButtons, IonIcon, IonButton, PeopleAssignedToShipmentAlert},
    props: ['users', 'name', 'job', 'type', 'stage', 'hide-accept-reject'],
    methods: {
        hasAcceptedMembership(membership) {
            return _.filter(membership, user => {
                if (!user.me) {
                    return false;
                }
                return user.pivot.accepted_at;
            }).length > 0;
        },

        /**
         * Pretty horrendous naming conventions in here, but the idea is you can
         * call getMembershipStatusColour and it'll return success, danger or
         * dark depending on what perspective you want to get it from.
         *
         * @param membership
         * @param state
         * @returns {string}
         */
        getMembershipStatusColour(membership, state) {
            const isState = _.filter(membership, user => {
                if (!user.me) {
                    return false;
                }
                if (state === 'accept') {
                    return user.pivot.accepted_at;
                }
                if (state === 'reject') {
                    return user.pivot.rejected_at;
                }
                return false;
            }).length > 0;

            if (state === 'accept' && isState) {
                return 'success';
            }
            if (state === 'reject' && isState) {
                return 'danger';
            }
            return 'dark';
        },
        acceptRejectJob(action) {

            const actionTitle = action.charAt(0).toUpperCase() + action.slice(1);

            const url = `/api/${this.type}/${this.job.id}/users`;

            alertController.create({
                header: `${actionTitle} ${this.name} Job?`,
                buttons: [{
                    text: 'Cancel',
                    role: 'cancel',
                }, {
                    text: actionTitle,
                    handler: () => {
                        EventBus().emitter.emit('loading', true);
                        this.$http.put(url, {
                            action: action,
                            stage: this.stage
                        }).then(() => {
                            this.$emit('updated');
                        }).finally(() => {
                            EventBus().emitter.emit('loading', false);
                        });
                    }
                }]
            }).then(alert => alert.present());
        },
        acceptJob() {
            this.acceptRejectJob('accept');
        },
        rejectJob() {
            this.acceptRejectJob('reject');
        },
    },
    setup() {
        return {
            peopleOutline,
            checkmarkCircleOutline,
            closeCircleOutline,
            ellipse
        }
    }
}
</script>
